/**
 * Created by noOne on 13/10/2017.
 */
"use strict";

export default class PausePanel extends PIXI.Sprite {
    constructor(holder, cb) {
        super(PIXI.Texture.EMPTY);

        this.cb = cb;

        holder.addChild(this);

        const panel = P3.createSprite("panel_pause", this);

        const lBtn = P3.simpleButton("small", "prev", this._btnDown.bind(this), this);
        lBtn.x = -panel.width * 0.5 + 62;
        lBtn.y = panel.height * 0.5 + 25;
        lBtn.dir = -1;
        panel.addChild(lBtn);

        /*

         const lBtn = P3.createButton({
         x: -panel.width * 0.5 + 62,
         y: panel.height * 0.5 + 25
         }, "small", this._btnDown.bind(this), this, {
         holder: panel,
         icon: "icon_prev"
         });
         lBtn.dir = -1;
         */
        /*
         const rBtn = P3.createButton({
         x: panel.width * 0.5 - 175,
         y: panel.height * 0.5 + 25
         }, "small", this._btnDown.bind(this), this, {
         holder: panel,
         icon: "icon_next"
         });
         rBtn.dir = 1;
         */
        const rBtn = P3.simpleButton("small", "next", this._btnDown.bind(this), this);
        rBtn.x = panel.width * 0.5 - 175;
        rBtn.y = panel.height * 0.5 + 25;
        rBtn.dir = 1;
        panel.addChild(rBtn);


        //console.log(Common.language);
        // console.log(Common.copy.help);
        // console.log(Common.copy.help[Common.language]);

        // const panelHeader = P3.simpleText("HOW TO PLAY", "consolas", 75, panel, 0x0);
        const panelHeader = createText(Common.copy.help[Common.language], {
            size: 60,
            fill: 0x929ebb
        });
        panelHeader.anchor.set(0.5);
        panelHeader.x = -60;
        panelHeader.y = 105;
        panel.addChild(panelHeader);

        /*
         const copy = "Lorem ipsum dolor sit amet, consectetur adipiscing \nelit. Morbi at viverra nisl.";
         // const tempBody = P3.simpleText("Lorem ipsum dolor sit amet, consectetur adipiscing \nelit. Morbi at viverra nisl.", "consolas", 25, panel, 0xffffff);
         const tempBody = createText(copy, {
         size: 28,
         fill: "white",
         wordWrapWidth: panel.width - 375
         }, "Fred Fredburger Regular");
         tempBody.anchor.set(0.5);
         tempBody.x = -50;
         tempBody.y = panel.height - 175;
         panel.addChild(tempBody);
         */


        //  this.scale.set(0.9);

        //this.anchor.set()

        /**
         * @type {boolean}
         * @private
         */
        this._animating = false;

        this._frames = [];

        this._currentFrame = 0;

        for (let i = 0; i < 4; i++) {
            let fr = P3.createSprite("fr_" + (i + 1), panel);
            fr.visible = false;
            this._frames.push(fr);
            fr.copy = createText(Common.copy["help_fr" + (i + 1)][Common.language], {
                size: 28,
                fill: "white",
                wordWrap: true,
                wordWrapWidth: panel.width - 400,
                align: "center"
            }, "Fred Fredburger Regular");
            fr.copy.anchor.set(0.5);
            fr.copy.x = -65;
            fr.copy.y = panel.height - 165;
            panel.addChild(fr.copy);
            fr.copy.visible = false;

            fr.pip = P3.createSprite("pip_off", panel);
            fr.pip.anchor.set(0.5);

            fr.pip.scale.set(0.75);

            fr.pip.x = -138 + i * 55;
            fr.pip.y = panel.height - 45;

        }

        this._btnDown({dir: 0});//init

        const playBtn = P3.simpleButton("big", "play", (e)=> {
            // this.animateOut();
            //this.end();
            this.cb.onUnpause(e);
        }, this);

        panel.addChild(playBtn);
        playBtn.x = panel.width * 0.5 - 225;
        playBtn.y = panel.height - 75;

        //  this._playBtn.x = Common.STAGE_WIDTH * 0.5;
        //  this._playBtn.y = P3.View.height * 0.5 + 200;

    }

    _btnDown(btn) {

        this._frames[this._currentFrame].visible = false;
        this._frames[this._currentFrame].copy.visible = false;
        this._frames[this._currentFrame].pip.texture = Common.assets.texture("pip_off");

        this._currentFrame += btn.dir;

        if (this._currentFrame < 0) this._currentFrame = 3;
        else if (this._currentFrame > 3) this._currentFrame = 0;

        this._frames[this._currentFrame].visible = true;
        this._frames[this._currentFrame].copy.visible = true;
        this._frames[this._currentFrame].pip.texture = Common.assets.texture("pip_on");
    }

    flipIn() {
        if (this._animating) return;
        this._animating = true;
        TweenMax.from(this.scale, 0.5, {
            y: -1,
            ease: Power0.easeNone,
            onComplete: ()=> {
                this._animating = false;
            }
        });
    }

    bounceIn() {
        if (this._animating) return;
        this._animating = true;
        TweenMax.from(this, 0.25, {
            y: -350,
            ease: Power1.easeOut,
            onComplete: ()=> {
                this._animating = false;
            }
        });
    }
}